<template>
  <div class>
    <cEditTickets
      :ticketingQueueResponse="lsRefundList"
      :ticketingQueueField="getAdminDataField()"
      :filterObject="getInitialFilterObj()"
      :orderStatusCount='orderStatusCount'
      @search="onApplyfilter"
      :isBooking="true"
    ></cEditTickets>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { COMPONENT_NAME, PATHNAME,DATE_TIME_FORMAT } from "../../../../util/constants";
import {
  addClassToBody,
  removeClassBody,
  cloneDeep
} from "../../../../util/util";
import { getCurrMonth, formatDate } from "../../../../util/date/dateFunctions";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";

import apiDetForRefund from "./../../../../services/apiDetForRefund";
import apiRefundList from "./../../../../services/apiRefundList";
import BaseConfiguration from "../../../../config/base";
import {
  handleJWT,
  getErrorAlertValue,
  handleSessionExist
} from "../../../../util/util";
import {
  ROUTER_PARAM,
  PAYMENT_PROCEED_TO,
  PROCEED_TO_TYPE
} from "../../../../util/constants";
import router, { navigate, goBack } from "../../../../router/index";
import cEditFlight from "./../../../../components/booking/flight/manage/cEditFlight";
import cEditTickets from "./../../../../components/booking/flight/manage/cEditTickets";
import cAlertModal from "./../../../../components/form/cAlertModal";

export default {
  name: COMPONENT_NAME.ALL_REFUND,

  components: {
    cEditTickets
  },

  data: () => {
    return {
      lsRefundList: [],
      orderStatusCount:[],

      alertValue: null
    };
  },

  methods: {
    ...mapActions("sAllRefund", {
     SET_FILTER_SEARCH_OBJ: "SET_FILTER_SEARCH_OBJ",
     SET_ALL_REFUND_RES:"SET_ALL_REFUND_RES"
    }),
    getInitialFilterObj() {
      try {
        if (BaseConfiguration.isDebug) console.log("getInitialFilterObj");
       if(this.GET_FILTER_SEARCH_OBJ){
         return this.GET_FILTER_SEARCH_OBJ;
       }else{
        return {
          orderId: null,
          pnr: null,
          firstName: null,
          lastName: null,
          departure: null,
          arrival: null,
          journeyType: null,
          travelDateFrom: null,
          travelDateTo: null,
          airline: null,
          b2bid: null,
          userId: null,
          ticketNumber: null,
          bookingDateFrom: formatDate(getCurrMonth().firstDate, DATE_TIME_FORMAT.API_DATE_FORMAT),
          bookingDateTo: formatDate(getCurrMonth().lastDay, DATE_TIME_FORMAT.API_DATE_FORMAT),
          b2bGroupId:null
        };
       }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ALL_REFUND,
          "error in getInitialFilterObj",
          err.toString(),
          "getInitialFilterObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getRefundList(pBookingObj) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getRefundList");
        this.SET_FILTER_SEARCH_OBJ(pBookingObj);

        if (pBookingObj) {
          let refundListReq = apiRefundList.buildRequest(pBookingObj);

          if (refundListReq != null) {
            let refundListRes = await apiRefundList.getResponse(refundListReq);

            if (VALIDATE_SUCCESS_RES(refundListRes)) {
                this.SET_ALL_REFUND_RES(refundListRes.data.data)

               this.orderStatusCount  =refundListRes.data.data.statusCount;
              if (refundListRes.data.data && refundListRes.data.data.bookings)

             
                retValue = refundListRes.data.data.bookings;
            } else {
              let error = getErrorMessage(refundListRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invallid Req";
          }
        } else {
          throw " invalid Booking object";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ALL_REFUND,
          "error in getRefundList",
          err.toString(),
          "getRefundList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async onApplyfilter(pFilterObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onApplyfilter");

        if (pFilterObj) {
          this.lsRefundList = await this.getRefundList(pFilterObj);
        } else {
          this.lsRefundList = [];
          this.orderStatusCount=null
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ALL_REFUND,
          "error in onApplyfilter",
          err.toString(),
          "onApplyfilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getAdminDataField() {
      if (BaseConfiguration.isDebug) console.log("getAdminDataField");
      return [
        {
          key: "bookingStatus",
          label: this.$t("mybookingPage.status"),
          isLocked: true
        },

        {
          key: "orderId",
          label: this.$t("mybookingPage.resId"),
          isLocked: true
        },
        {
          key: "passengername",
          label: this.$t("mybookingPage.name"),
          isLocked: false
        },

        {
          key: "contactmail",
          label: this.$t("mybookingPage.contact"),
          isLocked: false
        },

        {
          key: "journeytype",
          label: this.$t("mybookingPage.route"),
          isLocked: false
        },

        {
          key: "flight_number",
          label: this.$t("mybookingPage.flightNumber"),
          isLocked: false
        },
        {
          key: "departuredate",
          label: this.$t("mybookingPage.travelDate"),
          isLocked: false
        },

        {
          key: "pnr",
          label: this.$t("mybookingPage.pnr"),
          isLocked: false
        },
        {
          key: "ticketNumber",
          label: this.$t("mybookingPage.tcktNo"),
          isLocked: false
        },

        {
          key: "amount",
          label: this.$t("mybookingPage.amount"),
          isLocked: false
        },

        {
          key: "agencyname",
          label: this.$t("mybookingPage.bookedBy"),
          isLocked: false
        }
      ];
    }
  },

  computed:{
    ...mapGetters("sSysLogin", {
      GET_ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES",
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES",
    }),
     ...mapGetters("sAllRefund", {
             
                 GET_FILTER_SEARCH_OBJ:"GET_FILTER_SEARCH_OBJ"

            }),

  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
    // if(this.GET_ALL_REFUND_RES){
    //   this.lsRefundList=this.GET_ALL_REFUND_RES.bookings;
    //     this.orderStatusCount=this.GET_ALL_REFUND_RES.statusCount;

    // }else{
      this.lsRefundList = await this.getRefundList(this.getInitialFilterObj());

    // }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.ALL_REFUND,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

    beforeCreate() {    
   addClassToBody(COMPONENT_NAME.MY_BOOKING);
  },
  
   beforeDestroy() {
      
       removeClassBody();
    },
};
</script>

<style></style>
